import { SortType } from 'modules/types/PagingParams';
import { ButtonType } from 'modules/ui/button';
import {
  NavigationAndActionArrowAscending,
  NavigationAndActionArrowDescending,
  NavigationAndActionSortable,
} from 'modules/ui/icons';
import { theme } from 'modules/ui/theme';
import { useState } from 'react';
import { TableColumn } from '../TableColumn';
import {
  StyledCellContentContainer,
  StyledLabel,
  StyledSortButton,
  StyledTableHead,
} from './styled';
import { FilterWindow } from '../../../billsPage/components/FilterWindow';
import { Filter } from '../../../billsPage/redux/slice';
import {useTheme} from "styled-components";

export interface TableHeadProps {
  columns: TableColumn[];
  tableFilters?: Filter[];
  columnsMaxWidth?: string;
  onSort?: (
    column: string,
    newSort: SortType,
    newColumnsState?: TableColumn[],
  ) => void;
  checkboxFilters?: Filter[];
  fetchColumnCheckbox?: (column: TableColumn) => void;
  showFilterForColumn?: (accessor: string, filterType: string) => boolean;
  showSorting?: (accessor: string) => boolean;
}

export const TableHead: React.FC<TableHeadProps> = ({
  columns,
  tableFilters,
  columnsMaxWidth,
  onSort,
  checkboxFilters,
  fetchColumnCheckbox,
  showFilterForColumn,
  showSorting,
}) => {
  const [tableColumns, setTableColumns] = useState(columns);
  const [filterWindowActive, setFilterWindowActive] = useState<string>('');

  const toggleFilterWindowActive = () => {
    setFilterWindowActive('');
  };

  const handleFilterWindowChange = (column: TableColumn) => {
    setFilterWindowActive(
      filterWindowActive === column.label ? '' : column.label,
    );
  };

  const handleSortChange = (column: TableColumn, sortType: SortType) => {
    const newState = tableColumns.map((tableColumn) => {
      if (tableColumn.accessor === column.accessor) {
        let newSort;
        if (sortType === column.sort) newSort = SortType.DEFAULT;
        if (sortType === SortType.DESC && column.sort !== SortType.DESC)
          newSort = SortType.DESC;
        if (sortType === SortType.ASC && column.sort !== SortType.ASC)
          newSort = SortType.ASC;
        return { ...tableColumn, sort: newSort };
      }
      return tableColumn;
    });
    setTableColumns(newState);

    if (onSort) {
      const updatedColumn = newState.find(
        (tableColumn) => tableColumn.accessor === column.accessor,
      );
      if (updatedColumn && updatedColumn.sort) {
        onSort(updatedColumn.accessor, updatedColumn.sort, newState);
      }
    }
  };

  const iconBasedOnSortChange = (column: TableColumn) => {
    if (column.sort === SortType.DESC)
      return <NavigationAndActionArrowDescending />;
    if (column.sort === SortType.ASC)
      return <NavigationAndActionArrowAscending />;
    return <NavigationAndActionSortable />;
  };

  const theme = useTheme() as any;

  const colorBasedOnSortChange = (column: TableColumn) => {
    if (column.sort === SortType.DEFAULT) return theme.colors.primaryK10;
    return theme.colors.primaryT2;
  };

  return (
    <StyledTableHead>
      <tr>
        {tableColumns.map(
          (column) =>
            (column.renderIf === undefined || column.renderIf === true) && (
              <th key={column.accessor}>
                <StyledCellContentContainer columnsMaxWidth={columnsMaxWidth}>
                  {column.sort && (
                    <StyledSortButton
                      onClick={() => handleFilterWindowChange(column)}
                      type={ButtonType.Icon}
                      icon={iconBasedOnSortChange(column)}
                      color={colorBasedOnSortChange(column)}
                      hoverColor={theme.colors.primaryK7}
                      text={column.label}
                    />
                  )}
                  {!column.sort && (
                    <StyledLabel mobileOnly={column.mobileOnly}>
                      {column.label}
                    </StyledLabel>
                  )}
                </StyledCellContentContainer>
                {showFilterForColumn != null &&
                filterWindowActive === column.label ? (
                  <FilterWindow
                    tableFilters={tableFilters}
                    onClose={toggleFilterWindowActive}
                    column={column}
                    showCalendar={
                      showFilterForColumn &&
                      showFilterForColumn(column.accessor, 'calendar')
                    }
                    showSearch={
                      showFilterForColumn &&
                      showFilterForColumn(column.accessor, 'search')
                    }
                    showCheckbox={
                      showFilterForColumn &&
                      showFilterForColumn(column.accessor, 'checkbox')
                    }
                    onSortAscButtonClick={handleSortChange}
                    onSortDescButtonClick={handleSortChange}
                    fetchColumnCheckboxes={() => {
                      fetchColumnCheckbox && fetchColumnCheckbox(column);
                    }}
                    checkboxFilters={checkboxFilters}
                    showSorting={showSorting}
                  />
                ) : (
                  <div />
                )}
              </th>
            ),
        )}
      </tr>
    </StyledTableHead>
  );
};
